/**
 * Where a prepared action stands.
 *
 * The values are numbers because that is what the API sends: it serializes with
 * Newtonsoft.Json and registers no string-enum converter, so every enum it returns is an
 * integer. `Pending` is 0, so beware `state || fallback` - a genuinely pending action is
 * falsy.
 *
 * The lifecycle is deliberately explicit rather than "pending or done". `Executing` is the
 * server's durable note that a confirmation was accepted, written before the work runs, so a
 * process that dies mid-write leaves that behind rather than something that still looks
 * confirmable. `Unknown` is the honest answer when the work was attempted and nobody can say
 * whether it landed - which is why it is not `Failed`, and why the UI must never offer a
 * retry on it.
 */
export enum StagedActionState {
  Pending = 0,
  Executing = 1,
  Succeeded = 2,
  Failed = 3,
  Cancelled = 4,
  Expired = 5,
  Superseded = 6,
  Unknown = 7,
}

/** Whether this action is still waiting for the user to answer it. */
export const isPending = (state: StagedActionState): boolean =>
  state === StagedActionState.Pending;
